// Things that can be picked with the mouse in our system.
// "pick" is used in the computer graphics sense -- a point fires a ray down into
// the scene and "picks" something, so picks can be used for both hover and selection purposes

export class Pick {
	constructor(public readonly frameId?: string) {}

	isFrame(): this is { frameId: string; elementId: undefined } {
		return this.frameId !== undefined;
	}

	equals(other: Pick): boolean {
		if (this.frameId !== other.frameId) return false;
		return true;
	}
}
